import { render, staticRenderFns } from "./SwipperMobile.vue?vue&type=template&id=10b00edf&scoped=true&"
import script from "./SwipperMobile.vue?vue&type=script&lang=js&"
export * from "./SwipperMobile.vue?vue&type=script&lang=js&"
import style0 from "./SwipperMobile.vue?vue&type=style&index=0&id=10b00edf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b00edf",
  null
  
)

export default component.exports